import type { EmptyObject } from '@change-corgi/core/types';
import { Separator } from '@change-corgi/design-system/components/content';
import { Box } from '@change-corgi/design-system/layout';

import { SignaturesDistributionContainer } from '../SignaturesDistributionContainer';
import { SupporterVoices } from '../supportersVoices';

import { TheSupportersTitle } from './components/TheSupportersTitle';
import { TheSupportersContextProvider, useTheSupportersContext } from './shared/context';

const TheSupportersInner: React.FC<EmptyObject> = () => {
	const {
		data: { hasContent },
	} = useTheSupportersContext();

	if (!hasContent) {
		return <Box sx={{ display: 'none' }} data-testid="petition-page-supporters-section-hidden" />;
	}

	return (
		<>
			<Separator role="presentation" my={24} />
			<Box mb={[24, 64]}>
				<TheSupportersTitle />
				<SupporterVoices />
				<SignaturesDistributionContainer />
			</Box>
		</>
	);
};

export const TheSupporters: React.FC<EmptyObject> = () => {
	return (
		<TheSupportersContextProvider>
			<TheSupportersInner />
		</TheSupportersContextProvider>
	);
};
